import {
  Button,
  Card,
  Col,
  Divider,
  Pagination,
  Rate,
  Row,
  Space,
  Typography,
  message,
  notification,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useEffect, useState } from "react";
import axios from "axios"; // Import axios for API calls
import { useDispatch, useSelector } from "react-redux";
import { BASE_API_CONFIG } from "../../util/Api";
import { CHAT_BUSINESS_TYPE_ID } from "../../util/Constant";
import Title from "antd/lib/typography/Title";
import ratingImage from "../../assets/images/ratingsIcon.svg";
import getRelativeTime from "../myProfile/getDateIntervals";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";

const Ratings = ({
  selectedChat,
  selectedChatRatings,
  ratingReceiverId,
  quotationId,
}) => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [ratingDetails, setRatingDetails] = useState([]);
  const authUser = useSelector(({ auth }) => auth.userData);
  const [receiverCompanyName, setReceiverCompanyName] = useState(null);
  const [senderUserDetails, setSenderUserDetails] = useState(null);
  const [receiverUserDetails, setReceiverUserDetails] = useState(null);
  const userId = authUser.id;
  const token = authUser.token;
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(3);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedRatings = ratingDetails.slice(startIndex, endIndex);


  const getBusinessType = (businessTypeId) => {
    return CHAT_BUSINESS_TYPE_ID[businessTypeId] || "Unknown";
  };


  const handlePageChange = (page, newPageSize) => {
    setCurrentPage(page);
    if (newPageSize) {
      setPageSize(newPageSize);
    }
  };
  const fetchRatings = async () => {
    try {
      const response = await axios.get(
        `${BASE_API_CONFIG.baseURL}/ratings/${ratingReceiverId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRatingDetails(response.data.data.ratings);
    } catch (error) {
      console.error("Error submitting rating:", error);
    }
  };
  useEffect(() => {
    fetchRatings();
  }, [ratingReceiverId]);



  const totalRatings = ratingDetails.reduce(
    (sum, rating) => sum + rating.rating,
    0
  );
  const averageRating = totalRatings / ratingDetails.length;

  const formattedRating = (Math.round(averageRating * 10) / 10).toString();

  const userDetails = async () => {
    try {
      const userResponse = await axios.get(
        `${BASE_API_CONFIG.baseURL}/ratings/users`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const findSenderBusinessType = userResponse.data.find((user) => user.id === userId );
      setSenderUserDetails(findSenderBusinessType);

      const findReceiverBusinessType = userResponse.data.find((user) => user.id === Number(ratingReceiverId));
      setReceiverUserDetails(findReceiverBusinessType);

      const findReceiverCompanyName = userResponse.data.find((user) => user.id === Number(ratingReceiverId));
      setReceiverCompanyName(findReceiverCompanyName)

    } catch (error) {
      console.error("Error submitting rating:", error);
    }
  };

  useEffect(() => {
    userDetails();
  }, []);

  const companyName = receiverCompanyName?.companyName;

  const senderBusinessType = getBusinessType(
    senderUserDetails?.businessTypeId,
  );

  const receiverBusinessType = getBusinessType(
    receiverUserDetails?.businessTypeId,
  );

  const handleRatingSubmit = async () => {
    if (rating === 0) {
      notification.warning({
        message: "Warning",
        description: "Please select a rating before submitting.",
      });
      return;
    }
    dispatch(fetchStart());
    try {
      const defaultStatus = 'pending'; 
      const response = await axios.post(
        `${BASE_API_CONFIG.baseURL}/ratings?userId=${userId}`,
        {
          quotationId: Number(quotationId),
          rating: rating,
          ratingComments: comment,
          ratingSenderId: userId,
          ratingReceiverId: Number(ratingReceiverId),
          senderBusinessType: senderBusinessType,
          receiverBusinessType: receiverBusinessType,
          companyName: companyName,
          isactive: true,
          status: defaultStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchSuccess());
        setRating(0);
        setComment("");
        fetchRatings();
        notification.success({
          message: "Success",
          description: "Your rating has been submitted successfully.",
        });
      } else {
        notification.error({
          message: "Failed",
          description: "Failed to submit your rating.",
        });
      }
    } catch (error) {
      console.error("Error submitting rating:", error);
      message.error("Failed to submit rating. Please try again.");
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <Card
        style={{
          marginTop: "16px",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography.Title level={5} style={{ marginBottom: "16px" }}>
          Submit your ratings
        </Typography.Title>

        <Divider style={{ left: 0, top: "50px", position: "absolute" }} />

        <div style={{ margin: "20px" }}>
          <Typography.Text strong>Average Rating: </Typography.Text>
          <Rate
            value={rating}
            onChange={(value) => setRating(value)}
            style={{ marginLeft: "8px" }}
          />
        </div>

        <div style={{ marginBottom: "16px" }}>
          <TextArea
            rows={4}
            placeholder="Add a comment..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>

        <Button
          type="primary"
          onClick={handleRatingSubmit}
          disabled={rating === 0}
        >
          Submit
        </Button>
      </Card>

      {ratingDetails && ratingDetails.length > 0 && (
        <Card
          style={{
            borderRadius: "16px",
            padding: "1px",
          }}
        >
          <Row
            justify="space-between"
            align="middle"
            style={{
              borderRadius: "30px",
              padding: "16px",
            }}
          >
            <Col style={{ display: "flex", flexDirection: "column" }}>
              <Space>
                <Title level={4} className="myexim-table-title">
                  Client Reviews & Ratings
                </Title>
              </Space>
              <Typography>from {ratingDetails.length} businesses</Typography>
            </Col>
            <Col style={{ display: "flex", gap: "20px" }}>
              <Space padding="10px">
                <img
                  src={ratingImage}
                  alt="rate-img"
                  style={{ height: "50px", width: "40px" }}
                />
              </Space>
              <Typography.Text strong style={{ fontSize: "30px" }}>
                {formattedRating}/5
              </Typography.Text>
            </Col>
          </Row>

          <Divider style={{ left: 0, top: "100px", position: "absolute" }} />

          <Row
            style={{
              marginTop: "16px",
            }}
          >
            <Col span={24}>
              {paginatedRatings.map((rating) => (
                <Card
                  key={rating.id}
                  style={{
                    marginBottom: "16px",
                    borderRadius: "0",
                    border: "none",
                    borderBottom: "1px solid #d9d9d9",
                  }}
                >
                  <Typography.Text
                    strong
                    style={{
                      fontSize: "16px",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    {rating.companyName}
                  </Typography.Text>

                  <Space align="center" style={{ marginBottom: "16px" }}>
                    <Rate
                      disabled
                      defaultValue={rating.rating}
                      style={{ color: "#faad14", fontSize: "16px" }}
                    />
                    <Typography.Text
                      type="secondary"
                      style={{ margin: "0 4px" }}
                    >
                      •
                    </Typography.Text>

                    <Typography.Text
                      type="secondary"
                      style={{ color: "#727A84" }}
                    >
                      {getRelativeTime(rating.createdAt)}
                    </Typography.Text>
                  </Space>

                  <Typography.Paragraph>
                    {rating.ratingComments}
                  </Typography.Paragraph>
                </Card>
              ))}
            </Col>
          </Row>
          <Row justify={"end"} style={{ marginTop: "16px" }}>
            <Col>
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={ratingDetails.length}
                onChange={handlePageChange}
                onShowSizeChange={handlePageChange}
                showSizeChanger
                pageSizeOptions={[5]}
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`
                }
              />
            </Col>
          </Row>
        </Card>
      )}
    </div>
  );
};

export default Ratings;
